// extracted by mini-css-extract-plugin
module.exports = {"container":"ContractCheck_container__2NvGo","leftPanel":"ContractCheck_leftPanel__135HH","rightPanel":"ContractCheck_rightPanel__1ws_l"};